
import axios from 'axios';
import { REACT_APP_WORKING_URL } from '../Constants'
import { REACT_APP_WORKING_CHATAPI_URL } from '../Constants'

// 

export const getThemeListById = async(userId)=>{
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}document/getThemeListById/${userId}`,{
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

export const getThemeByThemeId = async(themeId)=>{
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}document/getThemeByThemeId/${themeId}`,{
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

export const createTheme = async(data)=>{
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.post(`${REACT_APP_WORKING_URL}document/createTheme`, data, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

export const deleteTheme = async(id)=>{
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.delete(`${REACT_APP_WORKING_URL}document/deleteTheme/${id}`, {}, {
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

export const getDocumentListByTheme = async(theme_id)=>{
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}document/getDocumentListByTheme/${theme_id}`,{
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

export const getNormalDocumentListByTheme = async(theme_id)=>{
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}document/getNormalDocumentListByTheme/${theme_id}`,{
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

export const getQuerBankDocumentListByTheme = async(theme_id)=>{
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}document/getQuerBankDocumentListByTheme/${theme_id}`,{
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

export const getQuestionListByTheme = async(theme_id)=>{
    const userInStorage = JSON.parse(localStorage.getItem('user'));
    const res = await axios.get(`${REACT_APP_WORKING_URL}quiz/getQuestionListByTheme/${theme_id}`,{
        headers: {
            authorization: `Bearer ${userInStorage.accessToken}`,
        },
    });
    return res.data;
}

